var _circle, _path, _path2, _path3, _circle2, _ellipse, _path4, _circle3, _ellipse2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "happy_1_",
    "data-name": "happy (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_576",
    "data-name": "Ellipse 576",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10504",
    "data-name": "Path 10504",
    d: "M21.329,11.329A10,10,0,0,1,3.545,17.608,10,10,0,0,0,17.608,3.545,9.989,9.989,0,0,1,21.329,11.329Z",
    transform: "translate(-1.329 -1.329)",
    fill: "#f4c534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10505",
    "data-name": "Path 10505",
    d: "M18.263,22.085a6.381,6.381,0,0,1-11.421.02.453.453,0,0,1,.652-.583A8.636,8.636,0,0,0,17.611,21.5.454.454,0,0,1,18.263,22.085Z",
    transform: "translate(-2.546 -8.035)",
    fill: "#3e4347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10506",
    "data-name": "Path 10506",
    d: "M17.322,9.824c-.339,2.306.882,4.394,2.731,4.666s3.62-1.375,3.959-3.682-.882-4.394-2.731-4.666S17.66,7.524,17.322,9.824Z",
    transform: "translate(-6.475 -2.292)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_577",
    "data-name": "Ellipse 577",
    cx: 1.673,
    cy: 1.673,
    r: 1.673,
    transform: "translate(12.09 7.553)",
    fill: "#3e4347"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_578",
    "data-name": "Ellipse 578",
    cx: 0.334,
    cy: 0.548,
    rx: 0.334,
    ry: 0.548,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 13.712, 8.502)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10507",
    "data-name": "Path 10507",
    d: "M10.6,9.824c.339,2.306-.883,4.394-2.731,4.666s-3.62-1.375-3.959-3.682.882-4.394,2.731-4.666S10.258,7.524,10.6,9.824Z",
    transform: "translate(-1.443 -2.292)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_579",
    "data-name": "Ellipse 579",
    cx: 1.673,
    cy: 1.673,
    r: 1.673,
    transform: "translate(4.564 7.553)",
    fill: "#3e4347"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_580",
    "data-name": "Ellipse 580",
    cx: 0.334,
    cy: 0.548,
    rx: 0.334,
    ry: 0.548,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 6.186, 8.502)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M14.265,26.977a6.318,6.318,0,0,0,3.134-.839,3.627,3.627,0,0,0-.637-.718,1.85,1.85,0,0,0-1.956-.221,3.3,3.3,0,0,1-1.349.27c-.613,0-1.458-.182-2.048.723-.016.024-.026.051-.041.076a6.335,6.335,0,0,0,2.9.709Z",
    transform: "translate(-4.263 -9.383)",
    fill: "#e24b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/excellent.579fe76ea13578592b30291a92e2e34c.svg";
export { ForwardRef as ReactComponent };